import React from 'react'

export default function MigrationProgress({steps, activeStepName}) {

    const stepItems = [];
    let activeStepReached = false;

    for (const step of steps){
        const nameSplit = step.name.split(',');
        const itemClass = !activeStepReached ? 'active' : '';
        stepItems.push((
            <li className={itemClass} key={step.name}>{step.label}</li>
        ))

        for (const n of nameSplit){
            if (activeStepName == n){
                activeStepReached = true;
            }
        }
    }

    return (
        <ol className='migration-step-list'>
            {stepItems}
        </ol>
    )
}
